function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#E4922F"
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6,
  y: 3,
  width: 4,
  height: 4,
  rx: 1,
  fill: "#F2F6FA"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3,
  y: 8,
  width: 4,
  height: 4,
  rx: 1,
  fill: "#F2F6FA"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 9,
  y: 8,
  width: 4,
  height: 4,
  rx: 1,
  fill: "#F2F6FA"
});

const SvgPoductRepacking = props => React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4);

export default SvgPoductRepacking;